const EMPTY_TABLE_CELL_MARKDOWN = /\|\s*(?:&nbsp;|\u00A0)\s*(?=\||$)/g

/**
 * TipTap serializes empty table cells as `&nbsp;`, which renders as literal text
 * when the markdown is loaded again. Strip those placeholders from table rows only.
 */
export function normalizeEmptyTableCellsInMarkdown(markdown: string): string {
  return markdown
    .split('\n')
    .map((line) => {
      if (!/^\s*\|/.test(line)) {
        return line
      }

      return line.replace(EMPTY_TABLE_CELL_MARKDOWN, '| ')
    })
    .join('\n')
}
